import React, { useEffect, useState } from 'react'
import { Link, Route } from 'react-router-dom'
import { motion } from 'framer-motion'
import { detect } from 'detect-browser'
import { setViewed } from 'redux/reducers/desktop'

import { clientLogo } from 'utils/theme'

import { useDispatch } from 'react-redux'
import { InfoOutlined } from '@mui/icons-material'
import Container from './styles'

const browser = detect()

export default ({ component: Component, usecamera, ...rest }) => {
  const dispatch = useDispatch()

  const [iosNotSupported, setIosNotSupported] = useState(false)
  const [isDesktop, setIsDesktop] = useState(false)

  function redirectToComponent() {
    dispatch(setViewed())
  }

  useEffect(() => {
    if (browser.os === 'iOS' && browser.name !== 'ios') {
      setIosNotSupported(true)
    }

    if (browser.os !== 'iOS' && browser.os !== 'Android OS') {
      setIsDesktop(true)
    }

    if (usecamera === false) {
      redirectToComponent()
    }
  }, [])

  return (
    <Route
      {...rest}
      render={(matchProps) => (
        <Container>
          <div className={isDesktop ? 'mobile_container' : 'full_width'}>
            <motion.header
              className="header"
              initial={{ opacity: 1 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.4 }}
            >
              <span>
                <Link to="/">
                  <img src={clientLogo} alt="Logo" className="header__logo" />
                </Link>
              </span>
            </motion.header>
            <div className="content">
              <main className="main">
                {!iosNotSupported && <Component {...matchProps} />}

                {iosNotSupported && (
                  <motion.p
                    className="not_supported"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.4 }}
                  >
                    <InfoOutlined />
                    Este navegador não é suportado na plataforma iOS!
                    <br />
                    <small>Tente novamente utilizando o navegador Safari.</small>
                  </motion.p>
                )}
              </main>
            </div>
          </div>
        </Container>
      )}
    />
  )
}
